import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Flame } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/book", label: "Book Slot" },
  { to: "/my-bookings", label: "My Bookings" },
  { to: "/admin", label: "Admin" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="w-8 h-8 grid place-items-center bg-[#CCFF00] text-black">
            <Flame strokeWidth={1.8} className="w-4 h-4" />
          </span>
          <span className="font-display text-2xl tracking-tight uppercase">
            Netflick<span className="text-[#CCFF00]"> &amp; </span>Chill
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold transition-colors ${
                  active
                    ? "text-[#CCFF00]"
                    : "text-white/70 hover:text-white"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <Link
          to="/book"
          data-testid="cta-book-nav"
          className="hidden md:inline-flex items-center px-5 py-2 bg-[#CCFF00] text-black text-xs uppercase tracking-[0.2em] font-bold hover:bg-[#D4FF33] transition-colors"
        >
          Book Now
        </Link>
      </div>
    </header>
  );
};
